import { ScaleElement } from '@scale/base-element';

class ScaleComparison extends ScaleElement {
  #initialPosition = 50;

  setup() {
    if (this.getAttribute('data-mode') !== 'slider') return;

    const slider = this.ref('slider');
    const before = this.ref('before');
    const container = this.ref('container');
    if (!slider || !before || !container) return;

    this.#initialPosition = this.getNumber('position', 50);
    slider.value = this.#initialPosition;
    this.#sync(this.#initialPosition);

    slider.addEventListener('input', () => this.#sync(slider.value), { signal: this.signal });
  }

  #sync(value) {
    const before = this.ref('before');
    const container = this.ref('container');
    if (!before || !container) return;

    const percent = parseFloat(value);
    container.style.setProperty('--compare', percent);
    before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
  }

  onBlockSelect() {
    const slider = this.ref('slider');
    if (slider) {
      slider.value = this.#initialPosition;
      this.#sync(this.#initialPosition);
    }
  }
}

if (!customElements.get('scale-comparison')) {
  customElements.define('scale-comparison', ScaleComparison);
}
